import React from 'react'
import { observer } from "mobx-react";
import { useStores } from "../../stores/rootStore";
import { Modal, Fade, Backdrop } from '@material-ui/core';
import "./index.css"

export const ModalWrapper = observer(() => {

    const { uiStateStore } = useStores();

    const handleClose = () => {
        uiStateStore.setModalOpen(false);
        uiStateStore.setModalContent(undefined);
    };

    return (
        <Modal
            className="modal-wrapper"
            open={uiStateStore.modalOpen}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={uiStateStore.modalOpen}>
                <div className="modal-content">
                    {uiStateStore.getModalContent()}
                </div>
            </Fade>
        </Modal>
    );

});